import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	chatMessageBuilderContainer: {
		height: 300
	}
})

export default useStyles
